/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const modeOfTransportJSON = async (): Promise<any> => {
  const modeOfTransport = useJSONStore.getState().modeOfTransport;
  const token = useUserStore.getState().userToken;
  const setModeOfTransport = useJSONStore.getState().setModeOfTransport;

  if (modeOfTransport.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.modeOfTransportBySupply}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setModeOfTransport(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default modeOfTransportJSON;
